import { createApi } from '@reduxjs/toolkit/query/react';
import { client } from '../../api/NestClient';
import { nestBaseQuery } from '../../utils/nestBaseQuery';
import type { components, paths } from '../../api/types/api';

/** Response type for GET /api/v1/users/consents */
export type GetUserConsentsResponse =
  paths['/api/v1/users/consents']['get']['responses']['200']['content']['application/json'];

/** Single consent item with the user's decision (if any) for the latest active version */
export type UserConsentItem = components['schemas']['UserConsentItemDto'];

/** Request body for PATCH /api/v1/users/consents */
export type UpdateUserConsentRequest = components['schemas']['UpdateUserConsentDto'];

/** Response type for PATCH /api/v1/users/consents */
export type UpdateUserConsentResponse =
  paths['/api/v1/users/consents']['patch']['responses']['200']['content']['application/json'];

export const consentsApi = createApi({
  reducerPath: 'consentsApi',
  baseQuery: nestBaseQuery,
  tagTypes: ['UserConsents'],
  endpoints: (builder) => ({
    getUserConsents: builder.query<GetUserConsentsResponse, void>({
      query: () => client.GET('/api/v1/users/consents'),
      providesTags: ['UserConsents'],
    }),
    updateUserConsent: builder.mutation<UpdateUserConsentResponse, UpdateUserConsentRequest>({
      query: (body) => client.PATCH('/api/v1/users/consents', { body }),
      invalidatesTags: ['UserConsents'],
    }),
  }),
});

export const {
  useGetUserConsentsQuery,
  useLazyGetUserConsentsQuery,
  useUpdateUserConsentMutation,
} = consentsApi;
